import {Navigate, Route, Routes} from "react-router-dom";
import MainLayout from "../layout/MainLayout/MainLayout";
import AppCatalog from "../pages/Authorized/AppCatalog/AppCatalog";
import Documentation from "../pages/Authorized/Documentation/Documentation";
import AuthLayout from "../layout/AuthLayout/AuthLayout";
import PrelandLayout from "../layout/PrelandLayout/PrelandLayout";
import Balances from "../pages/AdminAccess/Balances/Balances";
import Flows from "../pages/Authorized/Flows/Flows";
import PixelApi from "../pages/Authorized/PixelApi/PixelApi";
import IOSClicksStats from "../pages/Authorized/Statistics/IOS/IOSClicksStats/IOSClicksStats";
import IOSCloacaStats from "../pages/Authorized/Statistics/IOS/IOSCloacaStats/IOSCloacaStats";
import IOSCommonStats from "../pages/Authorized/Statistics/IOS/IOSCommonStats/IOSCommonStats";
import IOSGeoAppStats from "../pages/AdminAccess/Statistics/IOS/IOSGeoAppStats/IOSGeoAppStats";
import IOSUsersStats from "../pages/AdminAccess/Statistics/IOS/IOSUsersStats/IOSUsersStats";
import Transactions from "../pages/Authorized/Transactions/Transactions";
import EditPixelApi from "../pages/Authorized/PixelApi/EditPixelApi/EditPixelApi";
import Prelandings from "../pages/Authorized/Prelandings/Prelandings";
import CreatePrelanding from "../pages/Authorized/Prelandings/CreatePrelanding/CreatePrelanding";
import EditPrelanding from "../pages/Authorized/Prelandings/EditPrelanding/EditPrelanding";
import AllRedirectors from "../pages/Authorized/AllRedirectors/AllRedirectors";
import CreateFlow from "../pages/Authorized/CreateFlow/CreateFlow";
import FlowSettings from "../pages/Authorized/FlowSettings/FlowSettings";
import NewAuth from "../pages/Unauthorized/NewAuth/NewAuth";
import WebPrelanding from "../pages/Unauthorized/WebPrelanding/WebPrelanding";
import Page404 from "../pages/Authorized/Page404/Page404";
import ChangePassword from "../pages/Authorized/ChangePassword/ChangePassword";
import Management from "../pages/AdminAccess/Management/Management";
import EditUser from "../pages/AdminAccess/Management/EditUser/EditUser";
import IOSPostbackLogsStats from "../pages/Authorized/Statistics/IOS/IOSPostbackLogsStats/IOSPostbackLogsStats";
import SActivation from "../pages/Unauthorized/SActivation/SActivation";
import NewPassword from "../pages/Unauthorized/ResetPassword/NewPassword/NewPassword";
import EmailConfirm from "../pages/Unauthorized/ResetPassword/EmailConfirm/EmailConfirm";
import IOSConversionStats from "../pages/Authorized/Statistics/IOS/IOSConversionStats/IOSConversionStats";
import {is_tech_user, user_role} from "../storage/user";
import AndroidCommonStats from "../pages/Authorized/Statistics/Android/AndroidCommonStats/AndroidCommonStats";
import Subscriptions from "../pages/Authorized/SpecialAccess/Subscriptions/Subscriptions";
import Teams from "../pages/Authorized/SpecialAccess/Teams/Teams";
import EditTeamUser from "../pages/Authorized/SpecialAccess/Teams/EditTeamUser/EditTeamUser";
import EditTeam from "../pages/Authorized/SpecialAccess/Teams/EditTeam/EditTeam";
import {ownerAndTeamLeadList, TEAM_LEAD, teamsHighLevelAccess} from "../utils/vars/staticVariables";
import IosCustomerAnalytics from "../pages/AdminAccess/IosCustomerAnalytics/IosCustomerAnalytics";
import AndroidCustomerAnalytics from "../pages/AdminAccess/AndroidCustomerAnalytics/AndroidCustomerAnalytics";
import NewStatistics from "../pages/AdminAccess/NewStatistics/NewStatistics";
import Dashboard from "../pages/AdminAccess/Dashboard/Dashboard";
import SubscriptionsAccounting from "../pages/AdminAccess/SubscriptionsAccounting/SubscriptionsAccounting";


export const useRoutes = (isLogged) => {
    if (isLogged) {
        return (
            <Routes>
                <Route path="/" element={<PrelandLayout/>}>
                    <Route path="prelanding/preview" element={<WebPrelanding/>}/>
                </Route>

                <Route path="/" element={<MainLayout/>}>
                    <Route index element={<Navigate to="/app-catalog" replace/>}/>

                    <Route path="*" element={<Page404/>}/>
                    <Route path="app-catalog" element={<AppCatalog/>}/>

                    <Route path="my-flows/create-flow" element={<CreateFlow/>}/>
                    <Route path="my-flows/edit/:id" element={<FlowSettings/>}/>
                    <Route path="my-flows" element={<Flows/>}/>

                    <Route path="stats/android/common" element={<AndroidCommonStats/>}/>

                    <Route path="stats/ios/clicks" element={<IOSClicksStats/>}/>
                    <Route path="stats/ios/conversion" element={<IOSConversionStats/>}/>
                    <Route path="stats/ios/common" element={<IOSCommonStats/>}/>
                    <Route path="stats/ios/cloaca" element={<IOSCloacaStats/>}/>
                    <Route path="stats/ios/postback-logs" element={<IOSPostbackLogsStats/>}/>

                    {is_tech_user && (
                        <>
                            <Route path="dashboard" element={<Dashboard/>}/>
                            <Route path="subscriptions-accounting" element={<SubscriptionsAccounting/>}/>
                            <Route path="admin-statistics" element={<NewStatistics/>}/>
                            <Route path="stats/ios/geo+app" element={<IOSGeoAppStats/>}/>
                            <Route path="stats/ios/users" element={<IOSUsersStats/>}/>
                            {/*<Route path="balances" element={<Balances/>}/>*/}
                            <Route path="management" element={<Management/>}/>
                            <Route path="management/edit-user/:id" element={<EditUser/>}/>
                            <Route path="ios/customer-analytics" element={<IosCustomerAnalytics/>}/>
                            <Route path="android/customer-analytics" element={<AndroidCustomerAnalytics/>}/>
                        </>
                    )}

                    {
                        (ownerAndTeamLeadList.includes(user_role)) &&
                        <>
                            <Route path="subscriptions" element={<Subscriptions/>}/>
                            <Route path="teams" element={<Teams/>}/>
                        </>
                    }

                    <Route path="account" element={<ChangePassword/>}/>
                    {/*<Route path="teams/edit-user/:id" element={<EditTeamUser/>}/>*/}
                    {/*<Route path="teams/edit-team/:id" element={<EditTeam/>}/>*/}


                    <Route path="pixel-api" element={<PixelApi/>}/>
                    <Route path="pixel-api/edit/:id" element={<EditPixelApi/>}/>
                    <Route path="documentation" element={<Documentation/>}/>

                    {
                        teamsHighLevelAccess.includes(user_role) && <Route path="transactions" element={<Transactions/>}/>
                    }

                    <Route path="prelandings" element={<Prelandings/>}/>
                    <Route path="prelandings/create" element={<CreatePrelanding/>}/>
                    <Route path="prelandings/edit/:id" element={<EditPrelanding/>}/>

                    <Route path="all-redirectors" element={<AllRedirectors/>}/>
                </Route>
            </Routes>
        );
    }
    return (
        <Routes>
            <Route path="/" element={<AuthLayout/>}>
                <Route path="sactivation/*" element={<SActivation/>}/>
                <Route path="reset/new-password/*" element={<NewPassword/>}/>
                <Route path="reset/email-confirm" element={<EmailConfirm/>}/>
                <Route path="auth/login" element={<NewAuth/>}/>
                <Route index element={<Navigate to="/auth/login" replace/>}/>
                <Route path="*" element={<Navigate to="/auth/login" replace/>}/>
            </Route>

            <Route path="/" element={<PrelandLayout/>}>
                <Route path="prelanding/preview" element={<WebPrelanding/>}/>
            </Route>
        </Routes>
    );
};
